import { render } from "./App.vue?vue&type=template&id=73fea0f5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=73fea0f5&lang=css"

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__